export const trimFull = (value: string): string => {
  return value.replace(/ +/g, ' ').trim()
}
